// Browser storage can be blocked (private window, kiosk policy, cookies off):
// then even READING window.sessionStorage / window.localStorage throws.
// Every caller still guards its getItem/setItem; this only gets the handle.

/** window.sessionStorage ('session', the default) or window.localStorage ('local'), or null. */
export function safeStorage(kind = 'session') {
  try {
    if (typeof window === 'undefined') return null;
    return kind === 'local' ? window.localStorage : window.sessionStorage;
  } catch {
    return null;
  }
}

export default safeStorage;
